import * as API from '@/api';
import DEFINES from '@/defines';
import router from '../../router';
import {getField, updateField} from 'vuex-map-fields';
import i18n from '@/i18n';
import {isDateGreaterThenNow,isDateLessThenNow, generateNewUUID} from '@/helpers';
//initial state
function initialState () {
  return {
    uuid: generateNewUUID(),
    profile: null,
    screenings: [],
    OAuthApprovedDomains:[],
    groupTicketPurchases: [],
  };
}
const state = initialState ();

// actions

const actions = {
  async changePassword (context, payload) {
    var response = await API.consumer.changePassword (payload);
    return response;
  },
  async purchaseScreeningOrGroupTicket (context, payload) {
    var response = await API.consumer.purchaseScreeningOrGroupTicket (payload);
    context.dispatch ('listScreenings', payload);
    context.dispatch ('listGroupPurchases', payload);
    return response;
  },
  async enrollToScreening (context, payload) {
    var response = await API.consumer.enrollToScreening (payload);
    context.dispatch ('listScreenings', payload);
    return response;
  },
  async listScreenings (context, payload) {
    var response = await API.consumer.listScreenings (payload);
    context.commit ('set_screenings', response);
    return response;
  },
  async listGroupPurchases (context, payload) {
    var response = await API.consumer.listGroupPurchases (payload);
    context.commit ('set_group_ticket_purchases', response);
    return response;
  },

  async updateLiveCounter (context, payload) {
    await API.consumer.updateLiveCounter (payload);
  },

  async redeemCoupon (context, payload) {
    var response = await API.consumer.redeemCoupon (payload);
    return response;
  },
  async verifyShortCode (context, payload) {
    var response = await API.consumer.verifyShortCode (payload);
    return response;
  },

  async sendSupportRequest (context, payload) {
    var response = await API.consumer.sendSupportRequest (payload);
    return response;
  },
  async update (context, payload) {
    var response = await API.consumer.update (payload);
    context.commit ('set_profile', {
      consumer: response.consumer,
    });
    return response;
  },

  async subscribeNewsletter(context, payload) {
    var response = await API.consumer.subscribeNewsletter(payload);
    return response;
  },

  async isAlive(context, payload) {
    try {
      var response = await API.consumer.isAlive(payload);
      return response;
    } catch (error) {
      context.dispatch("app/showMessage", {
        message: error.message,
        color: "error"
      }, DEFINES.USE_ROOT);
    }
  },

  async listPhysicalEventBookings(context, payload){
    var response = await API.consumer.listPhysicalEventBookings(payload);
    return response;
  },

  async createCancellationRequest(context, payload){
    var response = await API.consumer.createCancellationRequest(payload);
    return response;
  },

  async getLockedBooking(context, payload){
    var response = await API.consumer.getLockedBooking(payload);
    return response;
  },

  async updateOAuthApprovedDomains (context, payload) {
    context.commit('update_oauth_approved_domains',{
     hostname: payload.hostname
    })
  },

  async markPurchaseProcessing (context, payload) {
    var response = await API.consumer.markPurchaseProcessing (payload);
    context.dispatch ('listScreenings', payload);
    context.dispatch ('listGroupPurchases', payload);
    return response;
  },

  async submitRefundModificationRequest (context, payload) {
    var response = await API.consumer.submitRefundModificationRequest (payload);
    return response;
  }
};

// getters
const getters = {
  getField,
  getConsumer: state => {
    return state.profile;
  },
  isSubscribed:(state, getters, rootState) => {
    let subscription = rootState.subscription.subscription;
    return (subscription && subscription.status == DEFINES.SUBSCRIPTION.STATUS.ACTIVE);
  },
  isEnrolled: state => screening_id => {
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return screening.pivot.is_enrolled;
    }
    return false;
  },
  isPurchased: state => screening_id => {
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return screening.pivot.is_purchased;
    }
    return false;
  },
  isPaymentInProcess : state => screening_id => {
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return !screening.pivot.is_purchased && screening.is_payment_in_process;
    }
    return false;
  },
  getVodEventStartTime: state => screening_id =>{
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return screening.pivot.event_starts_at;
    }
    return false;
  },
  getVodEventEndTime: state => screening_id =>{
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return screening.pivot.event_ends_at;
    }
    return false;
  },
  isVodEventActive: state => screening_id =>{
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      let event_end_date = screening.pivot.event_ends_at
      return event_end_date ?isDateGreaterThenNow(event_end_date) :false ;
    }
    return false;
  },
  isVodEventExpired: state => screening_id =>{
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      let event_end_date = screening.pivot.event_ends_at
      return event_end_date ?isDateLessThenNow(event_end_date) :false ;
    }
    return false;
  },
  getScreenings: (state, getters, rootState, rootGetters) => {
    let currentCompanyId = rootGetters['company/getCurrentCompanyId'];

    return state.screenings.filter (screening => {
      return currentCompanyId == screening.company_id;
    });
  },
  getGroupPurchases: (state, getters, rootState, rootGetters) => {
    let currentCompanyId = rootGetters['company/getCurrentCompanyId'];

    return state.groupTicketPurchases.filter (purchase => {
      return currentCompanyId == purchase.company_id;
    });
  },
  isScreeningGeoBlocked: state => screening_id => {
    let screening = state.screenings.find (screening => {
      return screening.id == screening_id;
    });
    if (screening) {
      return screening.is_geo_blocked;
    }
    return false;
  },
  isOAuthDomainApproved: state => hostname => {
    return state.OAuthApprovedDomains.includes(hostname)
  },
  hasGroupTicketPurchased: state => pricing_id => {
    let purchase = state.groupTicketPurchases.find (purchase => {
      return purchase.monetization_pricing_id == pricing_id && purchase.status == DEFINES.PURCHASE_STATUS.COMPLETED;
    });
    return purchase ? true : false;
  },
  hasGroupTicketPaymentInProcess: state => pricing_id => {
    let purchase = state.groupTicketPurchases.find (purchase => {
      return purchase.monetization_pricing_id == pricing_id;
    });
    if(purchase){
      return purchase.status == DEFINES.PURCHASE_STATUS.PROCESSING ? true : false;
    }
    return false;
  },
};

// mutations
const mutations = {
  updateField,
  set_profile (state, payload) {
    state.profile = payload.consumer;
  },

  set_screenings (state, payload) {
    state.screenings = payload.screenings;
  },
  set_group_ticket_purchases (state, payload) {
    state.groupTicketPurchases = payload.group_purchases;
  },
  update_oauth_approved_domains(state,payload) {
    let is_already_approved = state.OAuthApprovedDomains.includes(payload.hostname)
    if(!is_already_approved){
      state.OAuthApprovedDomains.push(payload.hostname)
    }
  },
  update_uuid(state,payload){
    state.uuid = payload.uuid
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
